import { __awaiter, __rest } from "tslib";
/**
 * 使用范围
 * 车辆管理->全部（我的）审批管理,车辆待审批详情页
 * */
import { createStore } from '@souche-f2e/muji';
import { dispatch } from '@@/store';
import { notification } from 'antd';
import API from '@/services';
import { setKey } from '@/shared/functions';
const typeList = {
    41: 'audit_wait_goods_data',
    21: 'audit_passed_goods_data',
    31: 'audit_reject_goods_data',
    14: 'my_wait_audit_goods_data',
    12: 'my_pass_audit_goods_data',
    13: 'my_reject_audit_goods_data',
    7: 'goods_status_audit_data',
    8: 'goodsstatus_data',
};
// desc 我的审批管理-全部审批管理通用数据
const approveCommonData = {
    // 全部审批成功
    tableSuccess: [],
    tableSuccessTotal: 0,
    pageIndexSuccess: 1,
    pageSizeSuccess: 20,
    checkedKeySuccess: [],
    checkedValSuccess: [],
    checkedNumSuccess: 0,
    loadingSuccess: false,
    // 全部待审批
    tableAll: [],
    tableAllTotal: 0,
    pageIndexAll: 1,
    pageSizeAll: 20,
    checkedKeyAll: [],
    checkedValAll: [],
    checkedNumAll: 0,
    loadingAll: false,
    // 全部审批驳回
    tableFail: [
        {
            carModel: '1',
            key: '1',
        },
        {
            carModel: '2',
            key: '2',
        },
        {
            carModel: '3',
            key: '3',
        },
    ],
    tableFailTotal: 0,
    pageIndexFail: 1,
    pageSizeFail: 20,
    checkedKeyFail: [],
    checkedValFail: [],
    checkedNumFail: 0,
    loadingFail: false,
    // 其他状态值
    activeTab: null,
    searchData: {},
    showReject: false,
    showRejectCallback: null,
    rejectId: null,
    showRecall: false,
    recallId: null,
    tableKey: 'goodsId',
};
// desc 我的审批管理-数据
const myData = {};
// desc 全部审批管理-数据
const AllData = {
    activeState: 0,
    allotData: [],
    showAllot: false,
};
// desc 审批管理数据
const approveData = Object.assign(Object.assign(Object.assign({}, myData), AllData), approveCommonData);
// desc 车辆待审批信息详情-数据
const detailData = {
    carDetails: {},
    exportParams: {},
};
export default createStore({
    state: Object.assign(Object.assign({ 
        // desc 因我的审批管理与全部待审批管理界面雷同度高，固复用全部待审批页面，穿参isMy 标识是否为我的审批管理
        isMy: false }, approveData), detailData),
    effects: {
        // desc 审批管理-更新表格
        updateTable({ page, acyiveKey }, { state }) {
            return __awaiter(this, void 0, void 0, function* () {
                const { activeTab, activeState, searchData } = state;
                let stateParams = {};
                let exportType = '';
                let realActiveTab = activeTab;
                if (!activeTab) {
                    realActiveTab = acyiveKey;
                    this.SET_STATE({
                        activeTab: realActiveTab,
                    });
                }
                switch (realActiveTab) {
                    case 'All':
                        stateParams = Object.assign({ status: 10 }, (state.isMy ? {} : { hasDistributed: activeState }));
                        state.isMy ? exportType = typeList[14] : exportType = typeList[41];
                        break;
                    case 'Success':
                        stateParams = { status: 30 };
                        state.isMy ? exportType = typeList[12] : exportType = typeList[21];
                        break;
                    case 'Fail':
                        stateParams = { status: 20 };
                        state.isMy ? exportType = typeList[13] : exportType = typeList[31];
                        break;
                    default:
                        break;
                }
                this.SET_STATE({
                    [`loading${realActiveTab}`]: true,
                });
                const searchParams = Object.assign(Object.assign({}, searchData), stateParams);
                const thenFn = (res) => {
                    this.SET_STATE({
                        [`table${realActiveTab}`]: res.items || [],
                        [`table${realActiveTab}Total`]: res.totalNumber || 0,
                        [`checkedVal${realActiveTab}`]: [],
                        [`checkedKey${realActiveTab}`]: [],
                        [`checkedNum${realActiveTab}`]: 0,
                        [`pageIndex${realActiveTab}`]: res.currentIndex,
                        exportParams: Object.assign(Object.assign({}, searchParams), { exportType }),
                    });
                    this.SET_STATE({
                        [`loading${realActiveTab}`]: false,
                    });
                };
                const finallyFn = () => {
                    this.SET_STATE({
                        [`loading${realActiveTab}`]: false,
                    });
                };
                state.isMy ?
                    API.goods.queryMyGoodsAuditList(Object.assign(Object.assign({}, searchParams), { pageNum: page || state[`pageIndex${realActiveTab}`], pageSize: state[`pageSize${realActiveTab}`] }))
                        .then(thenFn)
                        .finally(finallyFn)
                    :
                        API.goods.getApproveCar(Object.assign(Object.assign({}, searchParams), { pageNum: page || state[`pageIndex${realActiveTab}`], pageSize: state[`pageSize${realActiveTab}`] }))
                            .then(thenFn)
                            .finally(finallyFn);
            });
        },
        // desc 审批管理-跳转待审批车辆详情
        linkToDetail(link) {
            const { path, query } = link;
            dispatch.router.push({
                path,
                query,
            });
        },
        // desc 审批管理-撤回审批
        recallApprove(reason, { state }) {
            const { callback } = reason, otherSearch = __rest(reason, ["callback"]);
            API.goods.revocationAuditById(Object.assign({}, otherSearch))
                .then((res) => {
                notification.success({
                    message: '撤回审批成功',
                    description: res,
                });
                callback && callback();
            });
        },
        // desc [审批管理，待审批车辆详情]-通过审批
        agreeApprove({ idList, callback }, { state }) {
            API.goods.throughApprove({
                goodsIdList: JSON.stringify(idList),
            })
                .then(() => {
                notification.success({
                    message: '审批通过',
                    description: '车辆进入审批成功车辆',
                });
                const { pageIndexAll, isMy } = state;
                this.SET_STATE({
                    isMy,
                });
                this.updateTable({
                    page: pageIndexAll,
                    acyiveKey: 'All',
                });
                callback && callback();
            });
        },
        // desc [审批管理，待审批车辆详情]-驳回审批
        unAgreeApprove(remark, { state }) {
            console.log('unagree', remark, state.rejectId);
            this.SET_STATE({
                rejectId: null,
                showReject: false,
            });
            API.goods.disapprovalAuditById({
                goodsId: state.rejectId,
                remark,
            })
                .then((res) => {
                state.showRejectCallback && state.showRejectCallback(res);
                notification.success({
                    message: '已驳回成功',
                });
                const { pageIndexAll, isMy } = state;
                this.SET_STATE({
                    isMy,
                });
                this.updateTable({
                    page: pageIndexAll,
                    acyiveKey: 'All',
                });
            });
        },
        // desc 待分配数据-分配
        allotCar(person, { state }) {
            const name = state.allotData.filter((v) => {
                return person.checked === v.value;
            });
            console.log(name, state.checkedKeyAll);
            this.SHOW_ALLOT(false);
            API.goods.distributionAudit({
                listGoodsIds: state.checkedKeyAll,
                assessorId: name[0].id,
                assessor: name[0].label,
            })
                .then(() => {
                this.updateTable({});
                notification.success({
                    message: '分配成功',
                    description: '车辆进入分配者的待审批任务',
                });
            });
        },
        getAllot(params, { state }) {
            API.user.queryAccountList()
                .then((res = []) => {
                res.forEach((v, i) => {
                    res[i].label = res[i].nickname;
                    res[i].value = res[i].id;
                });
                // const useList = res.filter((v: any) => {
                //   return (v.status === 'ONSITE' && v.permissionList !== null && v.permissionPackList !== null);
                // });
                const useList = res.filter((v) => {
                    return v.status === 'ONSITE';
                });
                this.SET_STATE({
                    allotData: setKey(useList) || [],
                });
            });
        },
        // desc 重置数据
        resetState(params) {
            this.SET_STATE(Object.assign(Object.assign({}, approveData), detailData));
        },
    },
    reducers: {
        SET_STATE(state, payload) {
            Object.keys(payload)
                .forEach((key) => {
                if (typeof payload[key] !== 'undefined') {
                    state[key] = payload[key];
                }
            });
        },
        // desc 展示驳回Modal
        SHOW_REJECT(state, { isShow = true, id, callback }) {
            state.showReject = isShow;
            state.rejectId = isShow ? id : null;
            state.showRejectCallback = callback || null;
        },
        // desc 展示真实分配人员
        SHOW_ALLOT(state, isShow) {
            state.showAllot = isShow;
        },
        // desc 选中表格数据
        Selected_Table(state, params) {
            params.forEach((v) => {
                state[v.name] = v.data;
            });
        },
        CHANGE_PAGE_TYPE(state, isMy) {
            state.isMy = isMy;
            state.activeTab = approveCommonData.activeTab;
        },
    },
});
